import { useLocation } from 'react-router-dom';
import { StandalonePages } from '@constants';

export const useIsStandalonePage = () => {
  const location = useLocation();

  // Matched by path segment rather than substring: the guest route is a single letter,
  // and a substring test would make every page in the app look standalone.
  const segments = location.pathname.split('/');

  return StandalonePages.some((appRoute) => segments.includes(appRoute));
};
